import React, {} from "react" ;

import ScrollRails from "../../Common/Body/ScrollRails";
import ContactAppBodyHeader from "./ContactAppBodyHeader";

import {Route, Switch} from "react-router-dom";
import {getContactRouterPath, PATH_CONTACT_ROOT} from "root/Wieldy/routePaths";

import MessagingTab from "root/Wieldy/ApplicationModules/Messaging/Body/MessagingTab";

import {selectedContact} from "root/recoil/selectedContact";

import {useRecoilValue} from "recoil";

const ContactAppBody = (props) =>
{
    const current_contact = useRecoilValue(selectedContact);

    const contact_user_id = props.user_id;

    return (
        <div className="dt-module__container">

            <ContactAppBodyHeader contact_uid={current_contact.record?.user_id} contact_user_type_id={current_contact.record?.user_type_id} contact_known_as={current_contact.record?.known_as} document_id={current_contact.record?.document_id}/>

            <div className="dt-module__content ps-custom-scrollbar ps"
                 style={{height: props.height, width: props.width}}>

                <div className="dt-module__content-inner">
                    <div className="dt-module__list">
                        <Switch>
                            <Route path={getContactRouterPath('messaging')} render={(thisprops) => <MessagingTab contact_uid={contact_user_id} {...thisprops}/>}/>
                            <Route path={PATH_CONTACT_ROOT} render={(thisprops) => <MessagingTab contact_uid={contact_user_id} {...thisprops}/>}/>
                        </Switch>
                    </div>
                </div>

                <ScrollRails/>

            </div>
        </div>
    );
}

export default ContactAppBody;
